<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
<div class="float_tools">
  <router-link class="item_float" :class="{active: innerShowActive==1}" to="/">
    <div class="icon"><span class="icon_index"></span></div>
    <div class="name">首页</div>
  </router-link>
  <router-link class="item_float" :class="{active: innerShowActive==2}" to="/MyloveCar">
    <div class="icon"><span class="icon_bike"></span></div>
    <div class="name">我的爱车</div>
  </router-link>
  <router-link class="item_float" :class="{active: innerShowActive==3}" to="/Me">
    <div class="icon"><span class="icon_my"></span></div>
    <div class="name">个人中心</div>
  </router-link>
  <slot name="extra">
  </slot>
</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'FloatTools',
  components: {},
  props: ['showActive'],
  data () {
    return {
      innerShowActive: 0,
      backhomeUrl: '/',
      tmpName: 'FloatTools',
    }
  },
  computed: {
    ...mapState({
      cartCount: state => state.cartCount
    }),
  },
  watch: {},
  created() {
    const _this = this;
    //console.log(_this.showActive)

    //是否显示【active】
    if( typeof _this.showActive != 'undefined' ){
      _this.innerShowActive = _this.showActive;
    }

    //总部角色不显示【购物车】
    //if( _this.GLOBAL.loginUser.roletype == 2 ) _this.innerShowCart = false;

  },
  mounted() {
  },
  destroyed() {},
  methods: {
    funBack(){
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="less">
.float_tools {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #555;
  z-index: 100;
  .item_float {
    flex: 1;
    text-align: center;
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .material-icons {
      font-size: 20px;
    }
    .icon{
      span{
        display: block;
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .icon_index{
        background-image: url("../../static/img/loveCar/btm_index.png");
      }
      .icon_bike{
        background-image: url("../../static/img/loveCar/btm_bike.png");
      }
      .icon_my{
        background-image: url("../../static/img/loveCar/btm_my.png");
      }
    }
  }
  .item_float.active {
    // background-color: #4E66FF;
    color: #4E66FF;
    .icon{
      span{
        box-shadow:0 0 20px #EDF0F8;
      }
    }
    .icon_index{
        background-image: url("../../static/img/loveCar/btm_index_active.png");
      }
      .icon_bike{
        background-image: url("../../static/img/loveCar/btm_bike_active.png");
      }
      .icon_my{
        background-image: url("../../static/img/loveCar/btm_my_active.png");
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FloatTools.vue